export default "__VITE_PUBLIC_ASSET__36902c0a__"